var _rect, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCompletedActivityGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 4,
    fill: "#8ABB45"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 6,
    fill: "#E7F2DA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1148_7894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66666 8.99999L8.33333 10.6667L11.6667 7.33333",
    stroke: "#8ABB45",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1148_7894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompletedActivityGreen);
export default __webpack_public_path__ + "static/media/Icon_CompletedActivity_Green.6426777eb4d43be282e1b8e23bc8a974.svg";
export { ForwardRef as ReactComponent };